module.exports = __webpack_public_path__ + "static/microsoft-c554ccf20cc58b09ce8e4c1d48963888.svg";